import app from 'flarum/forum/app';
import {override} from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import MessagesPage from "./components/MessagesPage.jsx";
import BecomeAMemberPage from "./pages/BecomeAMemberPage.jsx";

/**
 * Disclaimer: Flarum documentation states that "new Extend.Routes().add(...)" works, but I think it requires execution
 * within the scope of an extension. Since this is in the main project scope, it apparently didn't work.
 *
 * Instead, fortunately, we can mutate the app.routes object directly.
 */

app.routes['messages.inbox'] = { path: '/messages', component: MessagesPage };
app.routes['messages.show'] = { path: '/messages/:id', component: MessagesPage };
app.routes['becomeAMember.show'] = { path: '/become-a-member', component: BecomeAMemberPage };

/**
 * When changing pages, ensure the composer/editor gets cleared.
 * Otherwise, if clicking "Reply" and then minimizing it, then starting a new discussion, you will still see the data
 * from the initial draft.
 */
override(Page.prototype, 'onremove', function(original) {
    if (app.composer.isVisible()) {
        app.composer.close();
    }
    return original();
});
